import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { getFavCats, getFavPractice, getFavProfessional, getFavSupplier, removeFavCats } from '../queries/catFav.query';
@Injectable()
export class CatFavService {

  constructor(private apollo: Apollo) { }

  getFavProfessional(id){
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: getFavProfessional,
      variables: {id}
    }).pipe(pluck('data', 'catalogue_favorites'));
  }

  getFaveSuplier(id){
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: getFavSupplier,
      variables: {id}
    }).pipe(pluck('data', 'catalogue_favorites'));
  }

  getFavPracice(id){
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: getFavPractice,
      variables: {id}
    }).pipe(pluck('data', 'catalogue_favorites'));
  }

  getFavCats(tagIdArray){

    console.log(tagIdArray)
    return  this.apollo.use("external").subscribe({
      query: getFavCats,
      variables: {tagIdArray}
    }).pipe(pluck('data', 'catalogues'));

  }

  removeCat(id: string): Observable<any> {
    console.log(id)
    return this.apollo.use("external").subscribe({
      query: removeFavCats,
      variables: {id}
    }).pipe(pluck('data', 'delete_catalogue_favorites'));
  }


}
